<template>
  <div class="form-group">
    <label class="mr-2" for="users"><input id="users" type="radio" v-model="localCondition" value="users"/> User Ids</label>
    <label class="mr-2" for="emails"><input id="emails" type="radio" v-model="localCondition" value="emails"/> User Emails</label>
    <label class="mr-2" for="userIds"><input id="userIds" type="radio" v-model="localCondition" value="userIds"/> User Ids</label>
  </div>
</template>

<script>

export default {
  props: {
    currentCondition: {
      type: String,
    },
  },
  data() {
    return {
      localCondition: this.currentCondition,
    };
  },
  watch: {
    currentCondition(newVal) {
      this.localCondition = newVal;
    },
    localCondition(newVal) {
      this.$emit('updateCurrentCondition', newVal);
    },
  },
}
</script>